module.exports = __webpack_public_path__ + "2bedddd171db70f176bdca92bbdfbc5a.pdf";